var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Title',{attrs:{"msg":"Ranking"}}),_c('Ranking')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }